import { SLUG_VALID_REGEX } from 'views/Content/ContentForm/constants';
import { z } from 'zod';

import { RadioButtonOptionsProps } from '../../../components/RadioButton/RadioButton';

export enum EPagesRadioButtonOptions {
  HIDDEN = 'hidden',
  VISIBLE = 'visible',
  SCHEDULED = 'scheduled'
}

export enum EPagesTemplateOptions {
  CONTENT = 'content',
  STORE = 'store',
  HOME = 'home'
}

export const pageTemplateOptions = [
  {
    value: EPagesTemplateOptions.CONTENT,
    label: EPagesTemplateOptions.CONTENT
  },
  {
    value: EPagesTemplateOptions.STORE,
    label: EPagesTemplateOptions.STORE,
    disabled: true
  },
  {
    value: EPagesTemplateOptions.HOME,
    label: EPagesTemplateOptions.HOME,
    disabled: true
  }
];

export enum EPagesVisibilityOptions {
  PUBLIC = 'public',
  SEGMENTED = 'segmented'
}

export const visibilityOptions = [
  {
    value: EPagesVisibilityOptions.PUBLIC,
    label: EPagesVisibilityOptions.PUBLIC
  },
  {
    value: EPagesVisibilityOptions.SEGMENTED,
    label: EPagesVisibilityOptions.SEGMENTED
  }
];

export const PAGES_RADIO_BUTTON_OPTIONS: RadioButtonOptionsProps[] = [
  {
    value: EPagesRadioButtonOptions.VISIBLE,
    id: EPagesRadioButtonOptions.VISIBLE,
    label: 'Visible'
  },
  {
    value: EPagesRadioButtonOptions.HIDDEN,
    id: EPagesRadioButtonOptions.HIDDEN,
    label: 'Hidden'
  }
];

export const FORM_SCHEMA = z.object({
  pageName: z.string().min(1, { message: 'This field is required.' }),
  pageIcon: z.string().min(1, { message: 'This field is required.' }),
  slug: z
    .string()
    .optional()
    .refine((val) => !val || SLUG_VALID_REGEX.test(val), {
      message:
        'This field can only contain letters, numbers, and hyphens. Cannot end with a hyphen.'
    }),
  pageTemplate: z.string().min(1, { message: 'This field is required.' }),
  visibility: z.string().min(1, { message: 'This field is required.' }),
  priority: z.coerce.number(),
  metadataImage: z.string().optional(),
  metadataDescription: z.string().optional(),
  state: z.enum([
    EPagesRadioButtonOptions.VISIBLE,
    EPagesRadioButtonOptions.HIDDEN,
    EPagesRadioButtonOptions.SCHEDULED
  ]),
  publishDate: z.string().optional(),
  isPublishDateEnabled: z.boolean().optional()
});
